import React from 'react';
import { ProviderMatchClinicalTrial } from '@kyruus/types';

import { ExpertiseEntryContainer } from './styles';

interface ClinicalTrialEntryProps {
  clinicalTrial: ProviderMatchClinicalTrial;
}

const ClinicalTrialsEntry = ({
  clinicalTrial
}: ClinicalTrialEntryProps): React.ReactElement => {
  const { official_title, brief_title, authority } = clinicalTrial;

  const trialsTitle = brief_title || official_title;
  const trialsSubtitle = authority;

  const trialsTitleMarkup =
    trialsTitle && trialsSubtitle ? (
      <span itemProp="name">{`${trialsTitle}: `}</span>
    ) : (
      <span itemProp="name">{trialsTitle}</span>
    );

  const trialsSubtitleMarkup = trialsSubtitle ? (
    <span itemProp="sponsor">{trialsSubtitle}</span>
  ) : null;

  return (
    <ExpertiseEntryContainer
      itemScope={true}
      itemType="https://schema.org/MedicalTrial"
    >
      {trialsTitleMarkup}
      {trialsSubtitleMarkup}
    </ExpertiseEntryContainer>
  );
};

export default ClinicalTrialsEntry;
